import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/common/ProtectedRoute';
import Layout from './components/layout/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import CategoryList from './pages/Categories/CategoryList';
import SubCategoryList from './pages/SubCategories/SubCategoryList';
import ProductList from './pages/Products/ProductList';
import StockInList from './pages/StockIn/StockInList';
import StockOutList from './pages/StockOut/StockOutList';
import InvoiceList from './pages/Invoices/InvoiceList';
import InvoiceForm from './pages/Invoices/InvoiceForm';
import PrintServiceList from './pages/PrintServices/PrintServiceList';
import PurchaseBillList from './pages/PurchaseBills/PurchaseBillList';
import PurchaseBillForm from './pages/PurchaseBills/PurchaseBillForm';
import PrintingBrandingList from './pages/PrintingBranding/PrintingBrandingList';
import Reports from './pages/Reports/Reports';
import UserList from './pages/Users/UserList';
import RoleList from './pages/Roles/RoleList';
import Settings from './pages/Settings/Settings';

function App() {
  return (
    <Router>
      <AuthProvider>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<Login />} />

          {/* Protected Routes */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Layout>
                  <Dashboard />
                </Layout>
              </ProtectedRoute>
            }
          />

          {/* Phase 2 Routes - Masters & Product Management */}
          <Route
            path="/categories"
            element={
              <ProtectedRoute>
                <Layout>
                  <CategoryList />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/sub-categories"
            element={
              <ProtectedRoute>
                <Layout>
                  <SubCategoryList />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/products"
            element={
              <ProtectedRoute>
                <Layout>
                  <ProductList />
                </Layout>
              </ProtectedRoute>
            }
          />

          {/* Phase 3 Routes - Inventory Transactions & Invoicing */}
          <Route
            path="/stock-in"
            element={
              <ProtectedRoute>
                <Layout>
                  <StockInList />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/stock-out"
            element={
              <ProtectedRoute>
                <Layout>
                  <StockOutList />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/invoices"
            element={
              <ProtectedRoute>
                <Layout>
                  <InvoiceList />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/invoices/create"
            element={
              <ProtectedRoute>
                <Layout>
                  <InvoiceForm />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/invoices/edit/:id"
            element={
              <ProtectedRoute>
                <Layout>
                  <InvoiceForm />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/invoices/view/:id"
            element={
              <ProtectedRoute>
                <Layout>
                  <InvoiceForm />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/print-services"
            element={
              <ProtectedRoute>
                <Layout>
                  <PrintServiceList />
                </Layout>
              </ProtectedRoute>
            }
          />
            <Route
              path="/print-services/view/:id"
              element={
                <ProtectedRoute>
                  <Layout>
                    <InvoiceForm />
                  </Layout>
                </ProtectedRoute>
              }
            />

          {/* Purchase Bills Routes */}
          <Route
            path="/purchase-bills"
            element={
              <ProtectedRoute>
                <Layout>
                  <PurchaseBillList />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/purchase-bills/new"
            element={
              <ProtectedRoute>
                <Layout>
                  <PurchaseBillForm />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/purchase-bills/:id/edit"
            element={
              <ProtectedRoute>
                <Layout>
                  <PurchaseBillForm />
                </Layout>
              </ProtectedRoute>
            }
          />

          {/* Printing/Branding Routes */}
          <Route
            path="/printing-branding"
            element={
              <ProtectedRoute>
                <Layout>
                  <PrintingBrandingList />
                </Layout>
              </ProtectedRoute>
            }
          />

          {/* Phase 4 Routes - Reports */}
          <Route
            path="/reports"
            element={
              <ProtectedRoute>
                <Layout>
                  <Reports />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/users"
            element={
              <ProtectedRoute>
                <Layout>
                  <UserList />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/roles"
            element={
              <ProtectedRoute>
                <Layout>
                  <RoleList />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <ProtectedRoute>
                <Layout>
                  <Settings />
                </Layout>
              </ProtectedRoute>
            }
          />

          {/* Default redirect */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
